import { isAxiosError } from "axios";
import * as ss from "superstruct";

const ApiErrorBody = ss.type({ message: ss.string() });

/** The server's message for a failed request, for people to read. */
export const apiErrorMessage = (cause: unknown): string => {
  const body = isAxiosError<unknown>(cause) ? cause.response?.data : undefined;

  if (ss.is(body, ApiErrorBody)) {
    return body.message;
  }

  return cause instanceof Error ? cause.message : String(cause);
};
